import { useEffect, useRef } from 'react';

const ACTIVITY_EVENTS = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll'];
const THROTTLE_MS = 500;

// Calls `onIdle` after `timeoutMs` of no user activity. Any of the tracked
// events resets the timer. Throttled to at most one reset every 500ms so a
// dragging mouse doesn't spam setTimeout. When `enabled` is false the hook
// installs no listeners — cheap to gate on isAuthenticated.
export function useIdleLogout({ timeoutMs, onIdle, enabled = true }) {
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  useEffect(() => {
    if (!enabled || !timeoutMs || timeoutMs <= 0) return undefined;

    let timer = null;
    let lastReset = 0;

    const fire = () => {
      onIdleRef.current?.();
    };

    const reset = () => {
      const now = Date.now();
      if (now - lastReset < THROTTLE_MS) return;
      lastReset = now;
      if (timer) clearTimeout(timer);
      timer = setTimeout(fire, timeoutMs);
    };

    reset();
    ACTIVITY_EVENTS.forEach((evt) =>
      window.addEventListener(evt, reset, { passive: true })
    );

    return () => {
      if (timer) clearTimeout(timer);
      ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, reset));
    };
  }, [enabled, timeoutMs]);
}
